module.exports = __webpack_public_path__ + "static/img/ic-report-question.01b8519d.svg";